function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4608_31830)",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.175 8.75h2.333c.35 0 .7.233.934.467l1.983 3.033 2.683.933c.467.117.817.584.817 1.05v5.017c0 .583-.467 1.167-1.167 1.167h-3.486"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.925 22.75a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.175 18.89V6.417c0-.7-.467-1.167-1.167-1.167H2.842c-.7 0-1.167.467-1.167 1.167V19.25c0 .583.467 1.167 1.167 1.167h1.746m13.997 0h-4.663"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.925 22.75a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.592 22.75a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667zM6.925 5.25v8.167M12.758 5.25v8.167"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4608_31830"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.8)",
  d: "M0 0h28v28H0z"
})))));